import { render } from "./gift-with-purchase.vue?vue&type=template&id=313cf620"
import script from "./gift-with-purchase.vue?vue&type=script&lang=js"
export * from "./gift-with-purchase.vue?vue&type=script&lang=js"

import "./gift-with-purchase.vue?vue&type=style&index=0&id=313cf620&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__